<template>
  <div class="diy-popper">
    <div class="diy-popper__trigger" aria-describedby="popper">
      <slot name="popper-trigger">
        <button>Click me</button>
      </slot>
    </div>
    <div class="diy-popper__template" role="popper" ref="popperTemplate">
      <div class="diy-popper__body" :style="`max-width:${maxWidth}px`">
        <!-- heading -->
        <div class="diy-popper__heading">
          <AppHeading tag="h4" :text="title" />
          <AppButtonIcon icon="far fa-times" @click="closePopper" />
        </div>
        <!-- Body inner -->
        <div class="diy-popper__body-inner">
          <!-- content -->
          <div class="diy-popper__content">
            <slot name="popper-content" :close-popper="closePopper" />
          </div>
          <!-- actions -->
          <div class="diy-popper__actions">
            <slot name="popper-action" :close-popper="closePopper" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { createTippy } from 'Plugins/tippy-js'
// Components
import AppHeading from 'Ui/AppHeading'
import AppButtonIcon from 'Ui/AppButtonIcon'

export default {
  name: 'DIYPopper',

  components: {
    AppHeading,
    AppButtonIcon,
  },

  props: {
    title: {
      type: String,
      default: 'DIY Popper',
    },

    placement: {
      type: String,
      default: 'top',
    },

    maxWidth: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      popperInstance: null,
    }
  },

  methods: {
    togglePopper() {
      this.popperInstance.state.isShown ? this.popperInstance.hide() : this.popperInstance.show()
    },

    closePopper() {
      this.popperInstance.hide()
    },

    emitShowingEvent() {
      this.$emit('showing')
    },

    emitShownEvent() {
      this.$emit('shown')
    },

    emitCloseEvent() {
      this.$emit('close')
    },

    async runSetup() {
      await this.$nextTick()
      const template = this.$refs.popperTemplate
      const trigger = this.$el.querySelector('.diy-popper__trigger').firstElementChild

      this.popperInstance = createTippy(trigger, template, {
        trigger: 'click',
        placement: this.placement,
        interactive: true,
        onShown: this.emitShownEvent,
        onHidden: this.emitCloseEvent,
      })
    },
  },

  created() {
    this.runSetup()
  },
}
</script>

<style scoped>
/* .diy-popper__template {
  z-index: 3;
} */

.diy-popper__body {
  padding: 10px 15px;
  max-width: 290px;
  height: 100%;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 15px -5px var(--rgba-default);
  overflow: hidden;
}

.diy-popper__heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid var(--c-secondary-400);
}

.diy-popper__heading >>> .app-heading {
  font-size: 14px;
  color: var(--c-secondary);
  width: 100%;
}

.diy-popper__heading .app-button--icon {
  font-size: 16px;
  line-height: 10px;
  flex: 0 0 30px;
  border-radius: 10px;
  background-color: transparent;
}

.diy-popper__content {
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  color: var(--c-primary);
  margin-top: 5px;
}

.diy-popper__heading .app-button--icon:hover {
  background-color: var(--c-secondary-300);
}
</style>
